import React from 'react';
import { PhoneInput } from '../shared/PhoneInput';

const PhoneInputField = ({ field, form, onChange, ...restProps }) => {
  const handleChange = (e) => {
    const { value } = e;

    form.setFieldValue(field.name, value);

    if (onChange) {
      onChange(value);
    }
  };

  const handleBlur = () => {
    form.setFieldTouched(field.name, true);
  };

  return (
    <PhoneInput
      {...field}
      {...restProps}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};

export default React.memo(PhoneInputField);
